/**
 * @file LineWordings.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-23
 * @modified 2026-10-23
 * @description An order line's two wordings, read only, with Create Customer
 *              Order's icons: Sale (sell — product_name, the invoice) over
 *              Purchase (shopping_cart — what the PO and the supplier's bill
 *              say). The order window (CustomerOrderModal) and Search Customer
 *              Orders' expanded lines (Cam, 23 Oct 2026) both show them; Create
 *              Customer Order's grid has the editable pair (OrderLinesGrid's
 *              DescriptionPair).
 *
 *   <LineWordings sale={line.product_name} purchase={purchase}
 *                 purchaseTitle="Purchase description: the words on PO-D10397" />
 *
 *   Renders the two rows as siblings (a fragment), so a grid cell can place
 *   them; each is .line-wording (and .po-line-description, which the order
 *   window's CSS already lays out).
 */

import React from 'react';
import './LineWordings.css';

const SALE_TITLE = 'Sales description: goes on the invoice';
const PURCHASE_TITLE = "Purchase description: goes on the purchase order and the supplier's bill";

function LineWordings({ sale, purchase, saleTitle = SALE_TITLE, purchaseTitle = PURCHASE_TITLE, purchaseMuted = false, empty = '-' }) {
  return (
    <>
      <div className="line-wording po-line-description" title={saleTitle}>
        <span className="material-symbols-rounded line-wording-icon" aria-hidden="true">sell</span>
        <span className="line-wording-text">{sale || empty}</span>
      </div>
      <div className={`line-wording po-line-description${purchaseMuted ? ' is-muted' : ''}`} title={purchaseTitle}>
        <span className="material-symbols-rounded line-wording-icon" aria-hidden="true">shopping_cart</span>
        <span className="line-wording-text">{purchase || empty}</span>
      </div>
    </>
  );
}

export default LineWordings;
